<template lang="pug">
    .notifications-list-wrapper
      .actions
        SearchWithButtons(
          v-model="search"
          :showSearch="true"
          :clientSide="true"
        )
      .notifications-list
        el-row
          el-col(:span='24')
            SoilSensorsList(
              :transmitters="transmitters"
            )
      .pagination
        Pagination(
          :view="'transmitters'"
          :fieldId="selectedFieldId"
          :search="search"
          @viewData="handleGetTransmitters"
          @handleTableLoading="handlePaginationLoading"
        )
</template>

<script>
import SearchWithButtons from "@components/_shared/SearchWithButtons";
import SoilSensorsList from "@components/client/details/SoilSensorsList";
import Pagination from "@components/_shared/Pagination";

export default {
  name: 'NotificationsList',

  components: {
    SoilSensorsList,
    SearchWithButtons,
    Pagination,
  },

  props: {
    selectedFieldId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      search: "",
      loading: false,
      transmitters: [],
    }
  },

  methods: {
    handleGetTransmitters(data) {
      this.transmitters = data;
    },

    handlePaginationLoading(loading) {
      this.loading = loading
    },
  }
}
</script>